import {
  Menu,
  MenuButton,
  MenuList,
  MenuGroup,
  MenuItem,
  MenuDivider,
  IconButton,
  useColorModeValue,
  Portal,
} from "@chakra-ui/react";
import {
  CollecticonEllipsisHorizontal,
  CollecticonUsers,
  CollecticonDownload2,
  CollecticonTrashBin,
} from "@devseed-ui/collecticons-chakra";
import Overline from "./Overline";
import DownloadDetections from "./DownloadDetections";
import { InferenceCollection } from "../types/inferences";

type SceneOptionsMenuProps = {
  sceneDate: string;
  inferences?: InferenceCollection | undefined;
  onDeleteScene?: () => void;
  onShareScene?: () => void;
  sceneId?: string;
  userRole: "owner" | "collaborator";
};

const SceneOptionsMenu = ({
  sceneDate,
  sceneId,
  inferences,
  onDeleteScene,
  onShareScene,
  userRole,
}: SceneOptionsMenuProps) => {
  const menuListHoverBg = useColorModeValue("gray.100", "whiteAlpha.100");
  const color = useColorModeValue("red.700", "red.400");
  const bg = useColorModeValue("red.50", "rgba(201, 6, 6, 0.1)");

  return (
    <Menu isLazy>
      <MenuButton
        as={IconButton}
        size="xs"
        ml="auto"
        variant="base-soft-outline"
        aria-label="Scene Options"
        title="Scene Options"
        isDisabled={userRole !== "owner"}
        icon={<CollecticonEllipsisHorizontal size="3" />}
      />
      <Portal>
        <MenuList zIndex="popover">
          <MenuGroup as={Overline} title="Scene Options" fontWeight="normal">
            {userRole === "owner" && (
              <MenuItem
                onClick={onShareScene}
                icon={<CollecticonUsers />}
              >
                Share Scene
              </MenuItem>
            )}
            {inferences && (
              <DownloadDetections
                as={MenuItem}
                variant="base-text"
                fileName={`scene-${sceneDate.slice(0, 20).replace(/,/g, "")}-inferences.csv`}
                sceneId={sceneId}
                inferences={inferences}
                px="3"
                gap="3"
                justifyContent="start"
                fontWeight="normal"
                _hover={{
                  background: menuListHoverBg,
                }}
                sx={{ "& > span": { display: "none" } }}
              >
                <CollecticonDownload2 />
                Download Detections
              </DownloadDetections>
            )}
            <MenuDivider />
            {userRole === "owner" && (
              <MenuItem
                onClick={onDeleteScene}
                color={color}
                _hover={{
                  background: bg,
                }}
                icon={<CollecticonTrashBin />}
              >
                Delete Scene
              </MenuItem>
            )}
          </MenuGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default SceneOptionsMenu;
